// extracted by mini-css-extract-plugin
export default {"sidebar_collapse":"SidebarCollapse_sidebar_collapse__RgiLn","sidebar_toggle":"SidebarCollapse_sidebar_toggle__LiFMA","open":"SidebarCollapse_open__lXbyE"};